import script from "./EmailSettingPreferencesEmailsInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmailSettingPreferencesEmailsInput.vue?vue&type=script&setup=true&lang=ts"

import "./EmailSettingPreferencesEmailsInput.vue?vue&type=style&index=0&id=6a3fe2f2&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a3fe2f2"]])

export default __exports__